// Layout.jsx
import React, { useState, useEffect } from 'react';
import Classes from './MainLayout.module.css';
import Sidebar from './Sidebar/Sidebar';
import { AnimatePresence } from 'framer-motion';
import SidebarPopup from './SidebarPopup/SidebarPopup';
import Header from './Header/Header';

const MainLayout = (props) => {

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const updateIsMobile = () => {
            setIsMobile(window.innerWidth < 1000);
        };

        updateIsMobile();
        window.addEventListener('resize', updateIsMobile);
        return () => window.removeEventListener('resize', updateIsMobile);
    }, []);

    const [openMobileSidebar, setopenMobileSidebar] = useState(false);

    return (
        <div className={Classes.container}>
            {/* Sidebar */}
            {!isMobile &&
                <Sidebar
                    isMobile={isMobile}
                    setopenMobileSidebar={setopenMobileSidebar}
                />
            }
            {/* Main Content */}
            <div className={Classes.mainContent}>
                {/* Top Navbar */}
                <Header
                    setopenMobileSidebar={setopenMobileSidebar}
                    isMobile={isMobile}
                />
                {/* Page Content */}
                <div className={Classes.pageContent}>
                    <div className={Classes.pageContentInner}>
                        {props.component}
                    </div>
                </div>
            </div>

            {isMobile &&
                <AnimatePresence>
                    {openMobileSidebar &&
                        <SidebarPopup
                            isMobile={isMobile}
                            setopenMobileSidebar={setopenMobileSidebar}
                        />
                    }
                </AnimatePresence>
            }
        </div>
    );
};

export default MainLayout;
